module.exports = __webpack_public_path__ + "img/sdg_pt-pt_(17).331b845a.png";